import { Component, forwardRef, OnInit, AfterViewInit, ViewChild, OnDestroy } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { DynamicComponentBase, IDynamicComponentConfig } from '../../../dynamic-component';

@Component({
  selector: 'app-d-slider',
  templateUrl: './d-slider.component.html',
  styles: [],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DSliderComponent),
      multi: true
    }
  ]
})
export class DSliderComponent extends DynamicComponentBase {
  static KEY = 'd-slider';

  constructor() {
    super();
  }

  configChange(config: IDynamicComponentConfig) {
    if (typeof config.value === 'number') {
      config.value = 0;
    }
  }
}
